module.exports = __webpack_public_path__ + "img/img_3.81f2d728.png";